import React, { useEffect, useRef } from 'react';
import { PaymentResponse } from '../types';
import { useLanguage } from '../i18n/LanguageProvider';

interface PaymentFormProps {
  paymentData: PaymentResponse;
  paymentPortalUrl: string;
}

const PaymentForm: React.FC<PaymentFormProps> = ({ paymentData, paymentPortalUrl }) => {
  const formRef = useRef<HTMLFormElement>(null);
  const submittedRef = useRef<boolean>(false);
  const { t } = useLanguage();

  useEffect(() => {
    const form = formRef.current;
    if (!form || !paymentPortalUrl || !paymentData || submittedRef.current) return;

    const hiddenInputs = Array.from(form.querySelectorAll<HTMLInputElement>('input[type="hidden"]'));
    console.log('🔎 Hidden inputs to be submitted:');
    console.table(hiddenInputs.map((i) => ({ name: i.name, value: i.value })));

    submittedRef.current = true;
    form.submit();
  }, [paymentPortalUrl, paymentData]);

  return (
    <div className="pp-redirect-wrap">
      <div className="pp-redirect-card">
        <div className="pp-redirect-spinner" />
        <div className="pp-redirect-text">{t('redirectingToPayment')}</div>
      </div>

      <form ref={formRef} method="POST" action={paymentPortalUrl} className="hidden">
        <input type="hidden" name="kosarica_sadrzaj" value={paymentData.kosarica_sadrzaj} />
        <input type="hidden" name="jezik" value={paymentData.jezik} />
        <input type="hidden" name="valuta" value={paymentData.valuta} />
        <input type="hidden" name="iznos" value={paymentData.iznos.toFixed(2)} />
        <input type="hidden" name="vrsta_transakcije" value={paymentData.vrsta_transakcije} />
        <input type="hidden" name="IBAN_proracun" value={paymentData.iban_proracun} />
        <input type="hidden" name="model_pnb" value={paymentData.model_pnb} />
        <input type="hidden" name="PNB" value={paymentData.pnb} />
        <input type="hidden" name="datum_vrijeme_zahtjeva" value={paymentData.datum_vrijeme_zahtjeva} />
        <input type="hidden" name="RKP" value={paymentData.rkp?.toString() || ''} />
        <input type="hidden" name="id_kosarica" value={paymentData.id_kosarica} />
        <input type="hidden" name="id_web_trgovina" value={paymentData.id_web_trgovina} />
        <input type="hidden" name="hash" value={paymentData.hash} />

        {paymentData.ime_korisnik && <input type="hidden" name="ime_korisnik" value={paymentData.ime_korisnik} />}
        {paymentData.prezime_korisnik && <input type="hidden" name="prezime_korisnik" value={paymentData.prezime_korisnik} />}
        {paymentData.adresa_korisnika && <input type="hidden" name="adresa_korisnika" value={paymentData.adresa_korisnika} />}
        {paymentData.grad_korisnik && <input type="hidden" name="grad_korisnik" value={paymentData.grad_korisnik} />}
        {paymentData.postanski_broj && <input type="hidden" name="postanski_broj" value={paymentData.postanski_broj} />}
        {paymentData.drzava_korisnik && <input type="hidden" name="drzava_korisnik" value={paymentData.drzava_korisnik} />}
        {paymentData.telefon_korisnik && <input type="hidden" name="telefon_korisnik" value={paymentData.telefon_korisnik} />}
        {paymentData.e_mail_korisnik && <input type="hidden" name="e_mail_korisnik" value={paymentData.e_mail_korisnik} />}
      </form>
    </div>
  );
};

export default PaymentForm;